import Axios from "axios";
import Firebase from "firebase";
import moment from "moment";

const AdminEventInfoStore = {
  namespaced: true,
  debug: true,
  state: {
    adminEventInfoList: [],
    adminEventInfoDetail: []
  },
  mutations: {
    setAdminEventInfoList(state, data) {
      state.adminEventInfoList = data;
    },
    setAdminEventInfoDetail(state, data) {
      state.adminEventInfoDetail = data;
    }
  },
  getters: {
    getAdminEventInfoList(state) {
      return state.adminEventInfoList.map(val => {
        let result = {
          EventId: val.eventid,
          Subject: val.subject,
          StartDate: moment(val.startdate).format("YYYY/MM/DD"),
          EndDate: moment(val.enddate).format("YYYY/MM/DD")
        };
        return result;
      });
    },
    getAdminEventInfoDetail(state) {
      let result = state.adminEventInfoDetail;
      result.startdate = moment(result.startdate).format("YYYY-MM-DD");
      result.enddate = moment(result.enddate).format("YYYY-MM-DD");
      return state.adminEventInfoDetail;
    }
  },
  actions: {
    async callApiAdminEventList({ commit }) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let adminEventInfoList = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/eventList",
            "",
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAdminEventInfoList", adminEventInfoList.data);
        })
        .catch(function() {
          // Handle error
        });
    },
    async callApiAdminEventDetail({ commit }, eventId) {
      await Firebase.auth()
        .currentUser.getIdToken(true)
        .then(async function(idToken) {
          let bearerToken = "Bearer " + idToken;
          let adminEventInfoDetail = await Axios.post(
            process.env.VUE_APP_API_URL + "api/admin/eventDetail",
            {
              EventId: eventId
            },
            {
              headers: {
                Authorization: bearerToken
              }
            }
          );
          commit("setAdminEventInfoDetail", adminEventInfoDetail.data[0]);
        })
        .catch(function() {
          // Handle error
        });
    }
  }
};
export default AdminEventInfoStore;
